export default __webpack_public_path__ + "static/media/3.60c2f1f3.png";